import { render, staticRenderFns } from "./detail-table.vue?vue&type=template&id=3f1c96ed&scoped=true"
import script from "./detail-table.vue?vue&type=script&lang=js"
export * from "./detail-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1c96ed",
  null
  
)

export default component.exports